import { AgGrid, Grid } from "@jsq/ds/core";
import { useAgGridDefaults } from "~/pages/UserAndRoles/utils/gridConfig";
import { RemoveRole } from "../../hooks";
import { useCanopyRolesTableConfiguration } from "./hooks";
type RolesRow = {
  groupName: string;
  removeRole: RemoveRole;
};

export type CanopyRolesType = {
  onGridReady?: (event: AgGrid.GridReadyEvent<RolesRow>) => void;
  rowData: RolesRow[];
  onFilterChanged?: (event: AgGrid.FilterChangedEvent) => void;
};
export const CanopyRoles = ({ rowData, onGridReady, onFilterChanged }: CanopyRolesType) => {
  const { columnDefs } = useCanopyRolesTableConfiguration();
  const { gridOptions } = useAgGridDefaults({
    overrides: {
      domLayout: "autoHeight",
      overlayNoRowsTemplate: "No roles found",
      suppressRowClickSelection: true,
      suppressCellFocus: true,
      statusBar: {
        statusPanels: [{ statusPanel: "agTotalRowCountComponent" }],
      },
      pagination: false,
    },
  });
  return (
    <Grid
      onGridReady={onGridReady}
      columnDefs={columnDefs}
      gridOptions={gridOptions}
      rowData={rowData}
      onFilterChanged={onFilterChanged}
    />
  );
};
